import { PipelineConfigInfo } from '../pipeline-config/types';
import {
  BtcGameContentQuery,
  BtcGameContentWithAssetsQuery,
  BtcScheduleQuery,
  SkywalkerZixiSource,
} from '../types/generated/graphql';

export type BtcScheduleGame = BtcScheduleQuery['schedule'][number];

export type BtcScheduleContent = BtcScheduleGame['content'][number];

export type BtcSchedulePipeline = BtcScheduleGame['pipelines'][number];

export type BtcScheduleMedia = BtcSchedulePipeline['media'][number];

export type BtcGame = BtcGameContentQuery['game'];

export type BtcGameContent = NonNullable<BtcGame>['content'][number];

export type BtcGameWithAssets = NonNullable<BtcGameContentWithAssetsQuery['game']>;

export type BtcGameContentWithAssets = NonNullable<BtcGameWithAssets>['content'][number];

export type BtcGameAsset = BtcGameContentWithAssets['assets'][number];

export type BtcGameBroadcast = BtcScheduleGame['broadcasts'][number];

export enum DecoderRegion {
  CENTRAL = 'CENTRAL',
  EAST = 'EAST',
}

export enum FeedTypeCode {
  AD = 'AD',
  HD = 'HD',
  ND = 'ND',
  UNKNOWN = 'UNKNOWN',
}

export type ZixiPipelineConfig = PipelineConfigInfo & {
  zixiSources?: Array<SkywalkerZixiSource>;
};
